<template>
	<div class="page" :style="{ height: fixedHeight + 'px' }" style="position: relative;overflow-y: auto;">
		<!-- 头部 -->
		<div class="titleView">
			<el-row>
				<el-col :span="4">申请批次号: {{ detailData.procureRequestNo }}</el-col>
				<el-col :span="4" v-if="detailData.createOperationInfo">申请日期:
					{{ detailData.createOperationInfo.operationTime }}</el-col>
				<el-col :span="4">期望到达日期: {{ detailData.expectTime }}</el-col>
				<el-col :span="4" v-if="detailData.createOperationInfo">申请人: {{ detailData.createOperationInfo.userName }}
				</el-col>
				<el-col :span="4">审批状态: 未审批</el-col>
				<el-col :span="4">
					<el-button type="warning" @click="handleBackClick" size="small">返回</el-button>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="4">门店确认: {{ detailData.isShopConfirm == false ? '不需要门店确认' : '需要门店确认' }}</el-col>
				<el-col :span="4">采购数量: {{ detailData.procureGoodsCount }}</el-col>
				<el-col :span="6">备注: {{ detailData.remarks == '' ? '- -' : detailData.remarks }}</el-col>
			</el-row>
		</div>
		<div class="scrollView" style="overflow-y: scroll;">
			<!-- 商品类 -->
			<div class="shopClass" v-if="shops.length > 0">
				<div class="comH2" @click="handleShopClick">
					<div>商品类</div>
					<i class="el-icon-caret-bottom" v-if="showShop"></i>
					<i class="el-icon-caret-top" v-else></i>
				</div>
				<div class="tableWarp" v-if="showShop">
					<el-table ref="multipleTable1" :data="shops" tooltip-effect="dark" size="small">
						<el-table-column :key="1" prop="title" label="商品名称" width="220" />
						<el-table-column :key="11" width="50">
							<template slot-scope="scope">
								<el-tag effect="dark" v-if="scope.row.procureGoodsState == 2" size="small" type="success">新</el-tag>
								<el-tag effect="dark" v-if="scope.row.procureGoodsState == 4" size="small">换</el-tag>
							</template>
						</el-table-column>
						<el-table-column :key="2" prop="brand" label="品牌" align="center" />
						<el-table-column :key="6" prop="barCode" label="条码" align="center" />
						<el-table-column :key="3" prop="skuValue" label="规格" align="center" width="120" />
						<el-table-column :key="5" prop="unit" label="单位" align="center" width="60" />
						<el-table-column :key="4" label="数量" align="center">
							<template slot-scope="scope">
								<el-input-number v-model="scope.row.count" controls-position="right" :min="1" :max="1000"
									style="width:100px" @change="handleCountChange(scope.row)" size="small" />
							</template>
						</el-table-column>
						<el-table-column :key="8" prop="shop_stock" label="库存" align="center" width="80">
							<template slot-scope="scope">
								<el-popover placement="right" width="200" trigger="click">
									<template v-if="scope.row.shop_stock&&scope.row.shop_stock.length > 0">
										<div v-for="(item, index) in scope.row.shop_stock" :key="index">
											{{ item.shopName }}:{{ item.stock }}
										</div>
									</template>
									<div v-else>无库存</div>
									<div slot="reference">库存<span class="el-icon-view" style="color: #F5882A;" /></div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column :key="9" prop="procureGoodsRemark" label="备注" align="center">
							<template slot-scope="scope">
								<el-input v-model="scope.row.procureGoodsRemark" v-if="scope.row.procureGoodsState == 2"
									placeholder="请输入备注"></el-input>
								<span v-else>{{ scope.row.procureGoodsRemark == '' ? '--' : scope.row.procureGoodsRemark }}</span>
							</template>
						</el-table-column>
						<el-table-column :key="10" fixed="right" label="操作" align="center" width="160">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click="handleDeleteClick(scope.row)">删除</el-button>
								<el-button type="text" size="small" @click='handleUpClick(scope.row)'
									v-if="scope.row.procureGoodsState != 4 && scope.row.procureGoodsState != 2">更换
								</el-button>
								<el-button type="text" size="small" @click='handleUpClick(scope.row)'
									v-if="scope.row.procureGoodsState == 4 && scope.row.procureGoodsState != 2">重新更换
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="allNum">
						<div>共{{ shopCount }}件</div>
					</div>
				</div>
			</div>
			<!-- 医疗类 -->
			<div class="shopClass" v-if="drugs.length > 0">
				<div class="comH2" @click="handleDrugClick">
					<div>医疗类</div>
					<i class="el-icon-caret-bottom" v-if="showDrug"></i>
					<i class="el-icon-caret-top" v-else></i>
				</div>
				<div class="tableWarp" v-if="showDrug">
					<el-table ref="multipleTable2" :data="drugs" tooltip-effect="dark" style="overflow:initial" size="small">
						<el-table-column :key="1" prop="title" label="商品名称" width="220" />
						<el-table-column :key="11" width="50">
							<template slot-scope="scope">
								<el-tag effect="dark" v-if="scope.row.procureGoodsState == 2" size="small" type="success">新</el-tag>
								<el-tag effect="dark" v-if="scope.row.procureGoodsState == 4" size="small">换</el-tag>
							</template>
						</el-table-column>
						<el-table-column :key="2" prop="brand" label="品牌" align="center" />
						<el-table-column :key="3" prop="skuValue" label="规格" align="center" width="120">
							<template slot-scope="scope">
								{{ scope.row.skuValue == '' ? '--' : scope.row.skuValue }}
							</template>
						</el-table-column>
						<el-table-column :key="5" prop="unit" label="单位" align="center" width="60" />
						<el-table-column :key="4" prop="count" label="数量" align="center">
							<template slot-scope="scope">
								<el-input-number v-model="scope.row.count" controls-position="right" :min="1" :max="1000"
									style="width:100px" @change="handleCountChange(scope.row)" size="small" />
							</template>
						</el-table-column>
						<el-table-column :key="8" prop="shop_stock" label="库存" align="center" width="80">
							<template slot-scope="scope">
								<el-popover placement="right" width="200" trigger="click">
									<template v-if="scope.row.shop_stock&&scope.row.shop_stock.length > 0">
										<div v-for="(item, index) in scope.row.shop_stock" :key="index">
											{{ item.shopName }}:{{ item.stock }}
										</div>
									</template>
									<div v-else>无库存</div>
									<div slot="reference">库存<span class="el-icon-view" style="color: #F5882A;" /></div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column :key="9" prop="procureGoodsRemark" label="备注" align="center">
							<template slot-scope="scope">
								<el-input v-model="scope.row.procureGoodsRemark" v-if="scope.row.procureGoodsState == 2"
									placeholder="请输入备注"></el-input>
								<span v-else>{{ scope.row.procureGoodsRemark == '' ? '--' : scope.row.procureGoodsRemark }}</span>
							</template>
						</el-table-column>
						<el-table-column :key="10" fixed="right" label="操作" align="center" width="160">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click="handleDeleteClick(scope.row)">删除</el-button>
								<el-button type="text" size="small" @click='handleUpClick(scope.row)'
									v-if="scope.row.procureGoodsState != 4 && scope.row.procureGoodsState != 2">更换
								</el-button>
								<el-button type="text" size="small" @click='handleUpClick(scope.row)'
									v-if="scope.row.procureGoodsState == 4 && scope.row.procureGoodsState != 2">重新更换
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="allNum">
						<div>共{{ drugCount }}件</div>
					</div>
				</div>
			</div>
			<!-- 耗材类 -->
			<div class="shopClass" v-if="haocais.length > 0">
				<div class="comH2" @click="handleHaocaiClick">
					<div>耗材类</div>
					<i class="el-icon-caret-bottom" v-if="showHaocai"></i>
					<i class="el-icon-caret-top" v-else></i>
				</div>
				<div class="tableWarp" v-if="showHaocai">
					<el-table ref="multipleTable2" :data="haocais" tooltip-effect="dark" style="overflow:initial">
						<el-table-column :key="1" prop="title" label="商品名称" width="220" />
						<el-table-column :key="11" width="50">
							<template slot-scope="scope">
								<el-tag effect="dark" v-if="scope.row.procureGoodsState == 2" size="small" type="success">新</el-tag>
								<el-tag effect="dark" v-if="scope.row.procureGoodsState == 4" size="small">换</el-tag>
							</template>
						</el-table-column>
						<el-table-column :key="2" prop="brand" label="品牌" align="center">
							<template>
								<span>--</span>
							</template>
						</el-table-column>
						<el-table-column :key="3" prop="skuValue" label="规格" align="center" width="120">
							<template>
								<span>--</span>
							</template>
						</el-table-column>
						<el-table-column :key="5" prop="unit" label="单位" align="center" width="60" />
						<el-table-column :key="4" prop="count" label="数量" align="center">
							<template slot-scope="scope">
								<el-input-number v-model="scope.row.count" controls-position="right" :min="1" :max="1000"
									style="width:100px" @change="handleCountChange(scope.row)" />
							</template>
						</el-table-column>
						<el-table-column :key="9" prop="procureGoodsRemark" label="备注" align="center">
							<template slot-scope="scope">
								<el-input v-model="scope.row.procureGoodsRemark" v-if="scope.row.procureGoodsState == 2"
									placeholder="请输入备注" @change="handleCountChange(scope.row)"></el-input>
								<span v-else>{{ scope.row.procureGoodsRemark == '' ? '--' : scope.row.procureGoodsRemark }}</span>
							</template>
						</el-table-column>
						<el-table-column :key="10" fixed="right" label="操作" align="center" width="160">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click="handleDeleteClick(scope.row)">删除</el-button>
								<el-button type="text" size="small" @click='handleUpClick(scope.row)'
									v-if="scope.row.procureGoodsState != 4 && scope.row.procureGoodsState != 2">更换
								</el-button>
								<el-button type="text" size="small" @click='handleUpClick(scope.row)'
									v-if="scope.row.procureGoodsState == 4 && scope.row.procureGoodsState != 2">重新更换
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="allNum">
						<div>共{{ haocaiCount }}件</div>
					</div>
				</div>
			</div>
			<!-- 修改记录 -->
			<div class="comH2" @click="handleUpdateClick" v-if="detailData.updateList && detailData.updateList.length > 0">
				<div>修改记录</div>
				<i class="el-icon-caret-bottom" v-if="showDrug"></i>
				<i class="el-icon-caret-top" v-else></i>
			</div>
			<div class="tableWarp xiugaiView" v-if="showUpadate">
				<el-row class="tableName">
					<el-col :span="12" align="center">原商品</el-col>
					<el-col :span="12" align="center">修改商品</el-col>
				</el-row>
				<el-table :data="detailData.updateList" size="small">
					<el-table-column :key="7" label="商品名称">
						<template slot-scope="scope">
							<span v-if="scope.row.procureGoodsReplace == null"></span>
							<span v-else>{{ scope.row.procureGoodsReplace.title }}</span>
						</template>
					</el-table-column>
					<el-table-column :key="8" label="品牌">
						<template slot-scope="scope">
							<span v-if="scope.row.procureGoodsReplace == null"></span>
							<span v-else>{{ scope.row.procureGoodsReplace.brand }}</span>
						</template>
					</el-table-column>
					<el-table-column :key="9" label="规格">
						<template slot-scope="scope">
							<span v-if="scope.row.procureGoodsReplace == null"></span>
							<span v-else>{{ scope.row.procureGoodsReplace.skuValue }}</span>
						</template>
					</el-table-column>
					<el-table-column :key="10" label="单位">
						<template slot-scope="scope">
							<span v-if="scope.row.procureGoodsReplace == null"></span>
							<span v-else>{{ scope.row.procureGoodsReplace.unit }}</span>
						</template>
					</el-table-column>
					<el-table-column :key="11" label="采购数量" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.procureGoodsReplace == null"></span>
							<span v-else>{{ scope.row.procureGoodsReplace.count }}</span>
						</template>
					</el-table-column>
					<el-table-column :key="12">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.state == 0" type="danger" effect="dark">已删除</el-tag>
							<el-tag v-if="scope.row.state == 2" type="success" effect="dark">已添加</el-tag>
							<el-tag v-if="scope.row.state == 4" effect="dark">已变更</el-tag>
						</template>
					</el-table-column>
					<el-table-column :key="1" label="商品名称" prop="procureGoods.title" />
					<el-table-column :key="2" label="品类" prop="procureGoods.skuValue">
						<template slot-scope="scope">
							<span v-if="scope.row.procureGoods.goodsType == 0">商品类</span>
							<span v-if="scope.row.procureGoods.goodsType == 1">医疗类</span>
							<span v-if="scope.row.procureGoods.goodsType == 7">耗材类</span>
						</template>
					</el-table-column>
					<el-table-column :key="3" label="品牌" prop="procureGoods.brand" />
					<el-table-column :key="4" label="规格" prop="procureGoods.skuValue" />
					<el-table-column :key="5" label="单位" prop="procureGoods.unit" />
					<el-table-column :key="6" label="采购数量" prop="procureGoods.count" align="center" />
					<el-table-column :key="13" label="删除备注" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.procureGoods.goodsType == 0">{{ scope.row.procureGoods.deleteRemark }}</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<!-- 底部按钮 -->
		<div class="fix_btn">
			<el-button type="warning" size="small" @click="handleAddgoodsClick()">添加商品</el-button>
			<el-button type="warning" size="small" @click="handleShopconfirm()">门店确认</el-button>
			<el-button v-if="$buttonAuthority('cangku2-shenpiList-apply')" type="warning" size="small"
				@click="handleCheckClick(0)">同意</el-button>
			<el-button type="warning" size="small" @click="handleCheckClick(1)">驳回</el-button>
		</div>
		<el-dialog title="请输入驳回理由" :visible.sync="dialogFormVisible" width="557px">
			<el-input v-model="textValue" autocomplete="off" type="textarea" placeholder="请输入5字以上" show-word-limit rows="6"
				resize="none" />
			<div slot="footer" class="dialog-footer">
				<el-button @click="handleBHCancelClick" size="small">取 消</el-button>
				<el-button type="warning" @click="handleBHDefineClick" size="small">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="请输入删除理由" :visible.sync="dialogRemoveVisible" width="557px">
			<el-input v-model="removeRemark" autocomplete="off" type="textarea" placeholder="请输入5字以上" show-word-limit rows="6"
				resize="none" />
			<div slot="footer" class="dialog-footer">
				<el-button @click="removeRemark = ''; dialogRemoveVisible = false" size="small">取 消</el-button>
				<el-button type="warning" @click="handleDeleteQRClick" size="small">确 定</el-button>
			</div>
		</el-dialog>


		<!-- 添加商品弹框 -->
		<div v-if="dialogAddShop_state">
			<dialogAddShop @closeOn="dialogAddShop_state = false" :addShopState.sync="dialogAddShop_state"
				@submit="selectShop" :tree.sync="tree"></dialogAddShop>
		</div>

	</div>
</template>
<script>
import { procureRequestDl } from "@/api/shopPurchaseApiNew.js"
import { shopConfirm, getCheck, removegoods, updategoods, addgoods, replacegoods, } from "@/api/purchaseApiNew.js"
import caigouFilter from '@/util/caigouFilter.js'
import dialogAddShop from "../../../components/dialog_addShopCG.vue"
export default {
	components: {
		dialogAddShop

	},
	data() {
		return {
			dialogAddShop_state: false, //添加商品
			shopList: [],
			dialogFormVisible: false,
			dialogRemoveVisible: false,
			textValue: '',
			fixedHeight: '',
			procureRequestNo: this.$route.query.procureRequestNo, //跳转订单id
			tabs: this.$route.query.tabs, //切换
			detailData: {}, //订单详情
			expectTime: '', //期望到达时间
			shops: [], //商品类
			drugs: [], //药品类
			haocais: [], //耗材类
			showShop: true, //显示商品类
			showDrug: true, //显示药品类
			showHaocai: true, //显示耗材类
			showUpadate: true, //显示修改记录
			shopCount: 0,
			drugCount: 0,
			drugPrice: 0,
			haocaiCount: 0,
			haocaiPrice: 0,
			stockVisible: false, //库存
			shopStocks: [],
			addGoodsType: false, //商品弹框状态   false是添加商品  true是更换
			old_goodsId: '', //更换前商品id
			tree: [{
				id: "602f1e89c904d9db7ccf3c03"
			}, {
				id: "602f1e88c904d9db7ccf3bec"
			}, {
				id: "6049cf035a0dfcc381f9311a"
			}],
			removeRemark: '', //删除备注
		}
	},
	mounted() {
		this.fixedHeight = document.documentElement.clientHeight - 76;
		this.getDetailData();
	},
	methods: {
		//返回按钮
		handleBackClick() {
			this.$confirm('是否退出当前页面？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$router.back();
				let storage = window.sessionStorage
				storage.setItem("tabs", 1)
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				});
			});
		},
		//添加商品
		handleAddgoodsClick() {
			this.addGoodsType = false
			this.dialogAddShop_state = true;
		},
		//展开修改记录
		handleUpdateClick() {
			this.showUpadate = !this.showUpadate
		},
		//更换按钮
		handleUpClick(row) {
			this.dialogAddShop_state = true;
			this.old_goodsId = row.id;
			this.addGoodsType = true
		},
		//添加商品组件选择事件
		selectShop(row) {
			let shops = this.shops;
			let drugs = this.drugs;
			let haocais = this.haocais;
			if (row.goodsType == 1) {
				if (drugs != undefined) {
					for (let i = 0; i < drugs.length; i++) {
						if (drugs[i].goodsId == row.goodsId) {
							this.$message({
								message: '该药品已重复添加',
								type: 'warning'
							})
							return
						}
					}
					if (!this.addGoodsType) {
						console.log(row.goodsItem,row,'药品');
						let parmars = {
							procureRequestNo: this.procureRequestNo,
							procureGoods: {
								goodsId: row.goodsItem.medical_id,
								title: row.goodsItem.title,
								skuId: '',
								skuValue: row.goodsItem.old_packinfo_info.sku_value,
								goodsType: 1,
								brand: row.goodsItem.brand_name,
								times: row.goodsItem.medical_ext_info.use_times,
								unit: row.wayItem,
								unitId: row.wayItem,
								procureGoodsRemark: row.procureGoodsRemark,
							},

						}
						addgoods(parmars).then((res) => {
							if (res.code == 0) {
								this.$message({
									message: '已添加',
									type: 'success'
								})
								this.getDetailData()
							}
						})
					} else {
						let parmars = {
							procureRequestNo: this.procureRequestNo,
							oldProcureGoodsId: this.old_goodsId,
							procureGoods: {
									goodsId: row.goodsItem.medical_id,
									title: row.goodsItem.title,
									skuId: '',
									skuValue: row.goodsItem.old_packinfo_info.sku_value,
									goodsType: 1,
									brand: row.goodsItem.brand_name,
									times: row.goodsItem.medical_ext_info.use_times,
									unit: row.wayItem,
									unitId: row.wayItem,
									procureGoodsRemark:row.procureGoodsRemark,
							}
						}
						replacegoods(parmars).then((res) => {
							if (res.code == 0) {
								this.$message({
									message: '已替换',
									type: 'success'
								})
								this.getDetailData()
							}
						})
					}

				}
			} else if (row.goodsType == 0) {
				if (shops != undefined) {

					for (let i = 0; i < shops.length; i++) {
						if (shops[i].goodsId === row.goodsId) {
							this.$message({
								message: '该商品已重复添加',
								type: 'warning'
							})
							return
						}
					}
					if (!this.addGoodsType) {
						let parmars = {
							procureRequestNo: this.procureRequestNo,
							procureGoods: {
								goodsId: row.goodsItem.goodsId,
								title: row.goodsItem.title,
								skuId: row.skuItem._id,
								skuValue: row.skuItem.skus_name,
								goodsType: 0,
								brand: row.goodsItem.brand_name,
								times: 1,
								unit: row.wayItem.packing_way_name,
								unitId: row.wayItem.packing_way_id,
								barCode: row.skuItem.barcode,
								procureGoodsRemark: row.procureGoodsRemark,
							},
						}
						addgoods(parmars).then((res) => {
							if (res.code == 0) {
								this.$message({
									message: '已添加',
									type: 'success'
								})
								this.getDetailData()
							}
						})
					} else {
						let parmars = {
							oldProcureGoodsId: this.old_goodsId,
							procureRequestNo: this.procureRequestNo,
							procureGoods: {
								goodsId: row.goodsItem.goodsId,
								title: row.goodsItem.title,
								skuId: row.skuItem._id,
								skuValue: row.skuItem.skus_name,
								goodsType: 0,
								brand: row.goodsItem.brand_name,
								times: 1,
								unit: row.wayItem.packing_way_name,
								unitId: row.wayItem.packing_way_id,
								barCode: row.skuItem.barcode,
								procureGoodsRemark:row.procureGoodsRemark,
							},
						}
						replacegoods(parmars).then((res) => {
							if (res.code == 0) {
								this.$message({
									message: '已替换',
									type: 'success'
								})
								this.getDetailData()
							}
						})
					}
				}
			} else if (row.goodsType == 7) {
				if (haocais != undefined) {
					for (let i = 0; i < haocais.length; i++) {
						if (haocais[i].goodsId == row.goodsId) {
							this.$message({
								message: '该耗材已重复添加',
								type: 'warning'
							})
							return
						}
					}
					if (!this.addGoodsType) {
						let parmars = {
							oldProcureGoodsId: this.old_goodsId,
							procureRequestNo: this.procureRequestNo,
							procureGoods: {
								goodsId: row.goodsItem.consumablematerial_id,
								title: row.goodsItem.title,
								skuId: '',
								skuValue: '',
								goodsType: 7,
								brand: row.goodsItem.brand_name,
								times: row.skuItem.use_times,
								unit: row.goodsItem.packing_unit,
								unitId: row.goodsItem.packing_unit,
								procureGoodsRemark: row.procureGoodsRemark,
							},
						}
						addgoods(parmars).then((res) => {
							if (res.code == 0) {
								this.$message({
									message: '已添加',
									type: 'success'
								})
								this.getDetailData()
							}
						})
					} else {
						let parmars = {
							id: this.id,
							oldProcureGoodsId: this.old_goodsId,
							procureRequestNo: this.procureRequestNo,
							procureGoods: {
								goodsId: row.goodsItem.consumablematerial_id,
								title: row.goodsItem.title,
								skuId: '',
								skuValue: '',
								goodsType: 7,
								brand: row.goodsItem.brand_name,
								times: row.skuItem.use_times,
								unit: row.goodsItem.packing_unit,
								unitId: row.goodsItem.packing_unit,
								procureGoodsRemark: row.procureGoodsRemark,
							},
						}
						replacegoods(parmars).then((res) => {
							if (res.code == 0) {
								this.$message({
									message: '已替换',
									type: 'success'
								})
								this.getDetailData()
							}
						})
					}
				}
			}
		},
		//修改数量
		handleCountChange(row) {
			let parmars = {
				id: row.id,
				count: row.count,
				procureGoodsRemark: row.procureGoodsRemark
			}
			updategoods(parmars).then(res => {
				if (res.code == 0) {
					this.$message({
						type: 'success',
						message: '修改成功'
					})
					this.getAllData()
				}
			})
		},
		// 获取合计
		getAllData() {
			let shops = this.shops;
			let drugs = this.drugs;
			let haocais = this.haocais;
			let shopCount = 0;
			let drugCount = 0;
			let haocaiCount = 0;
			if (shops.length > 0) {
				for (let i = 0; i < shops.length; i++) {
					shopCount = (shopCount + shops[i].count);
				}
				this.shopCount = shopCount;
			}
			if (drugs.length > 0) {
				for (let j = 0; j < drugs.length; j++) {
					drugCount = (drugCount + drugs[j].count);
				}
				this.drugCount = drugCount;
			}
			if (haocais.length > 0) {
				for (let k = 0; k < haocais.length; k++) {
					haocaiCount = (haocaiCount + haocais[k].count);
				}
				this.haocaiCount = haocaiCount;
			}
		},
		//展开商品类
		handleShopClick() {
			this.showShop = !this.showShop
		},
		//展开药品类
		handleDrugClick() {
			this.showDrug = !this.showDrug
		},
		//展开耗材类
		handleHaocaiClick() {
			this.showHaocai = !this.showHaocai
		},
		//门店确认
		handleShopconfirm() {
			let parmars = {
				procureRequestNo: this.detailData.procureRequestNo
			}
			shopConfirm(parmars).then((res) => {
				if (res.code == 0) {
					this.$message({
						type: 'success',
						message: '已通知'
					})
					this.getDetailData()
				}
			})
		},
		// 删除按钮
		handleDeleteClick(row) {
			this.deleteRow = row;
			this.dialogRemoveVisible = true;
		},
		// 删除弹框确认
		handleDeleteQRClick() {
			let parmars = {
				procureRequestNo: this.procureRequestNo,
				Ids: this.deleteRow.id,
				remark: this.removeRemark
			}
			removegoods(parmars).then((res) => {
				if (res.code == 0) {
					this.removeRemark = '';
					this.$message({
						type: 'success',
						message: '删除成功!'
					})
					this.dialogRemoveVisible = false;
					this.getDetailData()
				}
			})
		},
		//同意或者驳回按钮
		handleCheckClick(check) {
			if (check == 0) {
				if (this.detailData.isShopConfirm) {
					this.$message({
						type: 'warning',
						message: '请先点击门店确认按钮'
					})
					return
				}
				this.$confirm('是否同意此申请单?', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let parmars = {
						procureRequestNo: this.procureRequestNo,
						isCheck: true,
						checkRemark: ''
					}
					getCheck(parmars).then((res) => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '已同意'
							})
							this.$router.go(-1)
						}
					})
				}).catch((err) => {
					this.$message({
						type: 'info',
						message: '暂未同意'
					})
				})
			} else {
				this.dialogFormVisible = true
			}
		},
		//驳回弹框取消
		handleBHCancelClick() {
			this.dialogFormVisible = false;
			this.textValue = '';
		},
		//驳回弹框确定
		handleBHDefineClick() {
			if (this.textValue.length < 5) {
				this.$message({
					type: 'warning',
					message: '请输入5字以上'
				})
				return
			}
			let parmars = {
				procureRequestNo: this.procureRequestNo,
				isCheck: false,
				checkRemark: this.textValue
			}
			getCheck(parmars).then((res) => {
				if (res.code == 0) {
					this.$message({
						type: 'success',
						message: '已驳回'
					})
					this.dialogFormVisible = false;
					this.textValue = '';
					this.$router.go(-1)
				}
			})
		},
		//获取详情
		getDetailData() {
			let parmars = {
				procureRequestNo: this.procureRequestNo
			}
			procureRequestDl(parmars).then((res) => {
				if (res.code == 0) {
					this.detailData = res.data;
					// let price = 0;
					let detail = res.data;
					let shopList = []; //商品列表
					let drugList = []; //药品列表
					let haocaiList = []; //耗材列表

					for (let i = 0; i < detail.procureGoodsList.length; i++) {
								let ArrC=detail.procureGoodsList.filter((item)=>{
              return item.goodsType===0;
            });
						let ArrY=detail.procureGoodsList.filter((item)=>{
              return item.goodsType===1;
            });
						if(ArrC&&ArrC.length){
							this.$util.getGoodsInfoCaigou(ArrC,0).then((goodsList) => {
								for (let i = 0; i < goodsList.length; i++) {
									goodsList[i].skuStocks = goodsList[i].skuStocks || [];
									for (let a = 0; a < goodsList[i].skuStocks.length; a++) {
                  if (
                    goodsList[i].skuValue == goodsList[i].skuStocks[a].skuValue
                  ) {
                    this.$set(
                      goodsList[i],
                      "shop_stock",
                      goodsList[i].skuStocks[a].lstStock
                    );
                   
                  }
                }
								}
						})
						}
						if(ArrY&&ArrY.length){
							this.$util.getGoodsInfo(ArrY,1).then((goodsList) => {
								for (let i = 0; i < goodsList.length; i++) {
									goodsList[i].skuStocks = goodsList[i].skuStocks || [];
									for (let a = 0; a < goodsList[i].skuStocks.length; a++) {
                  if (
                    goodsList[i].skuValue == goodsList[i].skuStocks[a].skuValue
                  ) {
                    this.$set(
                      goodsList[i],
                      "shop_stock",
                      goodsList[i].skuStocks[a].lstStock
                    );
                   
                  }
                }
								}
						})
						}
								if (detail.procureGoodsList[i].goodsType == 0 && (detail
									.procureGoodsList[i].procureGoodsState == 1 || detail
										.procureGoodsList[i].procureGoodsState == 2 || detail
											.procureGoodsList[i].procureGoodsState == 4)) {
									shopList[i] = detail.procureGoodsList[i]
								} else if (detail.procureGoodsList[i].goodsType == 1 && (
									detail.procureGoodsList[i].procureGoodsState == 1 || detail
										.procureGoodsList[i].procureGoodsState == 2 || detail
											.procureGoodsList[i].procureGoodsState == 4)) {
									drugList[i] = detail.procureGoodsList[i]
								} else if (detail.procureGoodsList[i].goodsType == 7 && (
									detail.procureGoodsList[i].procureGoodsState == 1 || detail
										.procureGoodsList[i].procureGoodsState == 2 || detail
											.procureGoodsList[i].procureGoodsState == 4)) {
									haocaiList[i] = detail.procureGoodsList[i]
								}
								this.expectTime = '';
								this.shops = shopList.filter((item) =>  {
									if(item){
										return item
									}
									
								});
								this.drugs = drugList.filter((item) =>  {
									if(item){
										return item
									}
									
								});
								this.haocais = haocaiList.filter((item) =>  {
									if(item){
										return item
									}
									
								});
								console.log(this.haocais,'haocais');
								this.getAllData()
							
					}

				} else {
					this.$message({
						message: res.info,
						type: 'warning'
					});
				}
			})
		},
	}
}
</script>
<style lang="scss" scoped>
.page {
	display: flex;
	flex-direction: column;

	// 重复头部
	.titleView {
		width: 99%;
		padding: 20px 0;
		padding-left: 10px;
		margin: 0 auto;
		font-size: 14px;
		color: #2A2A2A;
		background: #fff;
		border-radius: 6px;
	}

	//重复标题
	.comH2 {
		line-height: 64px;
		font-size: 18px;
		display: flex;
		align-items: center;
	}

	.comH2 div {
		margin-left: 20px;
		margin-right: 6px;
		font-weight: bold;
	}

	.comH2 img {
		width: 16px;
		height: 16px;
		background: red;
	}

	.scrollView {
		flex: 1;
	}

	.scrollView::-webkit-scrollbar {
		display: none;
	}

	.tableWarp {
		border-radius: 6px;
		background: #fff;
		padding: 20px 30px;

		.tableName {
			line-height: 46px;
			background: #F7F6F9;
			font-size: 18px;
			color: #2A2A2A;
			font-weight: bold;
			margin-bottom: 10px;
		}

		.allNum {
			font-size: 14px;
			background: #F5F5F5;
			height: 50px;
			display: flex;
			align-items: center;
			padding-left: 20px;

			div:nth-of-type(1) {
				margin-right: 20px;
			}
		}
	}

	.fix_btn {
		width: 100%;
		height: 72px;
		background: #fff;
		display: flex;
		align-items: center;
		justify-content: flex-end;

		button {
			margin-right: 30px;
		}

		button:nth-of-type(5) {
			margin-right: 60px;
		}
	}

	.xiugaiView {
		max-height: 400px;
		overflow-y: scroll;
	}

	.xiugaiView::-webkit-scrollbar {
		display: none;
	}
}
</style>
